interface IProps {
  lightColor?: string;
  baseColor?: string;
}

export default function Waves({ lightColor = "#1582D9", baseColor = "#018757" }: IProps) {
  return (
    <svg
      width="101%"
      height={153}
      viewBox="0 0 390 153"
      style={{
        position: 'absolute',
        bottom: 0,
      }}
    >
      <defs>
        <linearGradient id="paint0" x1="138.5" y1="107" x2="461.097" y2="57.5" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor={lightColor} stopOpacity={0.7} />
          <stop offset="1" stopColor={baseColor} stopOpacity={0.7} />
        </linearGradient>

        <linearGradient id="paint1" x1="415.552" y1="144.5" x2="27.5518" y2="77.5" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor={baseColor} stopOpacity={0.7} />
          <stop offset="1" stopColor={lightColor} stopOpacity={0.7} />
        </linearGradient>

        <linearGradient id="paint2" x1="652.5" y1="480.5" x2="-40.9483" y2="-50.4999" gradientUnits="userSpaceOnUse">
          <stop offset="0.567116" stopColor={baseColor} stopOpacity={0.7} />
          <stop offset="0.76828" stopColor={lightColor} stopOpacity={0.7} />
        </linearGradient>
      </defs>

      <path
        d="M-32.5968 0.332123C-34.0926 1.08948 -34.7898 2.9361 -34.1862 4.56277C-95.4031 188 -40.9373 540.673 84.4998 507.5C136.003 495.083 373.654 375.27 426 379C478.094 382.54 522.821 115.517 565.391 146.266C566.842 147.314 568.771 147.233 570.133 146.064C571.488 144.9 571.972 142.931 571.289 141.235C533.515 47.3593 431.778 1.00995 339.235 25.0886C257.539 42.9435 179.304 90.0116 95.2182 91.51C40.2888 92.1289 -2.46263 49.257 -28.4488 1.69412C-29.2821 0.167206 -31.0867 -0.43338 -32.5968 0.332123Z"
        fill="url(#paint0)"
      />

      <path
        d="M521.246 20.332C522.741 21.0894 523.439 22.936 522.835 24.5627C466.022 177.415 514.937 463.673 389.5 430.5C337.997 418.083 2.34625 375.77 -50 379.5C-102.094 383.04 -34.1722 135.518 -76.7426 166.266C-78.1937 167.314 -80.1225 167.233 -81.4842 166.064C-82.8398 164.9 -83.3234 162.931 -82.6406 161.235C-44.8666 67.3594 56.8708 21.01 149.414 45.0887C231.11 62.9436 309.345 110.012 393.431 111.51C448.36 112.129 491.111 69.257 517.098 21.6941C517.931 20.1671 519.735 19.5665 521.246 20.332Z"
        fill="url(#paint1)"
      />

      <path
        d="M476.789 88.1677C478.122 89.1844 478.472 91.1269 477.582 92.6168C660.052 298.5 444 434.5 164.473 354.496C116.085 332.922 -78.848 385.349 -131 379.5C-182.87 373.511 -90.314 100.46 -137.765 122.957C-139.383 123.724 -141.264 123.293 -142.391 121.897C-143.512 120.505 -143.63 118.481 -142.65 116.938C-88.4392 31.4935 20.029 4.41204 106.652 44.9136C183.741 77.3231 252.115 137.83 334.528 154.59C388.429 165.185 438.262 130.799 472.462 88.7529C473.559 87.403 475.443 87.1404 476.789 88.1677Z"
        fill="url(#paint2)"
      />
    </svg>
  );
}